import { API_BASE_URL, apiRoutes } from "../../../constants";
import { useCallback, useState } from "react";
import Axios from "axios";

const pageSize = 10;

const getSerializedParam = (
  objectToSerialize,
  filterName,
  currentFilter = ""
) => {
  for (const [, [key, value]] of Object.entries(
    Object.entries(objectToSerialize)
  )) {
    if (value !== "" && value) {
      currentFilter += `${
        currentFilter.length ? "&" : ""
      }${filterName}[${key}]=${encodeURIComponent(value)}`;
    }
  }
  return currentFilter;
};

const formatContractApiData = (apiRes) =>
  apiRes?.map((resData) => {
    const apiAttributes = resData?.attributes;
    delete resData?.attributes;
    return { ...resData, ...apiAttributes };
  });

const getContractOptions = (contractData, excludeSelectOption) => {
  let contractArray = [];
  if (contractData?.length > 0) {
    _.forEach(_.orderBy(contractData, "name", "asc"), (contract) => {
      contractArray.push({
        label: contract.name,
        value: contract.id,
      });
    });
  }
  return contractArray;
};

const useContractOptions = (excludeSelectOption = false) => {
  const [contracts, setContracts] = useState([]);
  const [isContractLoading, setIsContractLoading] = useState(false);
  const [prevSearchQuery, setPrevSearchQuery] = useState("");
  const [currSearchQuery, setCurrSearchQuery] = useState("");
  const [currPage, setCurrPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [pageEnd, setPageEnd] = useState(false);

  const token = localStorage.getItem("access_token");
  const config = {
    headers: {
      Authorization: `JWT ${token}`,
      "content-type": "multipart/form-data",
    },
  };

  const getContractSelectedOption = (contractIDValue) => {
    let contractObj = null;
    if (contracts?.length > 0) {
      const selectedOption = _.find(
        contracts,
        (contractData) => contractData?.value === contractIDValue
      );
      if (selectedOption) contractObj = { ...selectedOption };
    }
    return contractObj;
  };

  const getPaginationSettings = (page) => ({
    size: pageSize,
    number: page,
  });

  const loadNextContractOptionsPage = async () => {
    if (pageEnd) return;
    if (!(totalCount == 0) && totalCount <= currPage * pageSize) {
      setPageEnd(true);
      return;
    }
    const page = totalCount == 0 ? 1 : currPage + 1;
    let filter = "";
    filter = getSerializedParam(getPaginationSettings(page), "page", filter);
    if (String(currSearchQuery ?? "").length)
      filter = getSerializedParam(
        { search: currSearchQuery },
        "filter",
        filter
      );
    setCurrPage(page);

    const searchURL = new URL(`${API_BASE_URL}${apiRoutes.contract}`);
    searchURL.search = filter;

    setIsContractLoading(true);
    Axios.get(searchURL, config)
      .then(({ data: apiData }) => {
        if (!apiData?.data?.length) {
          setPageEnd(true);
        } else {
          const formatedData = formatContractApiData(apiData?.data);
          const newOptions = getContractOptions(
            formatedData,
            excludeSelectOption
          );
          setContracts((currContracts) => [...currContracts, ...newOptions]);
          setTotalCount(apiData?.meta?.pagination?.count);
        }
      })
      .finally(() => {
        setIsContractLoading(false);
      });
  };

  const searchContractOptions = (resolveCallback, searchQuery) => {
    setCurrSearchQuery(searchQuery);
    setCurrPage(1);
    setPageEnd(false);
    let filter = "";
    filter = getSerializedParam(getPaginationSettings(1), "page", filter);
    if (String(searchQuery ?? "").length)
      filter = getSerializedParam({ search: searchQuery }, "filter", filter);

    const searchURL = new URL(`${API_BASE_URL}${apiRoutes.contract}`);
    searchURL.search = filter;

    setIsContractLoading(true);
    Axios.get(searchURL, config)
      .then(({ data: apiData }) => {
        if (!apiData?.data?.length) {
          resolveCallback(getContractOptions([], excludeSelectOption));
          setTotalCount(0);
          setPageEnd(true);
        } else {
          const formatedData = formatContractApiData(apiData?.data);
          const newOptions = getContractOptions(
            formatedData,
            excludeSelectOption
          );
          setContracts(newOptions);
          setTotalCount(apiData?.meta?.pagination?.count);
          resolveCallback(newOptions);
          if (
            apiData?.meta?.pagination?.count <=
            apiData?.meta?.page * pageSize
          )
            setPageEnd(true);
        }
        setPrevSearchQuery(searchQuery);
      })
      .finally(() => {
        setIsContractLoading(false);
      });
  };
  const handleContractSearch = useCallback(
    (searchValue, onResolveCallBack = () => {}) => {
      if (searchValue == "" && String(prevSearchQuery ?? "").length == 0)
        return;
      if (_.inRange(String(searchValue ?? "").length, 1, 2)) {
        if (String(prevSearchQuery ?? "").length >= 2) {
          searchContractOptions(onResolveCallBack, "");
          return;
        } else {
          onResolveCallBack(contracts);
          return;
        }
      }
      searchContractOptions(onResolveCallBack, searchValue);
    },
    [contracts, prevSearchQuery]
  );

  const getAllContracts = useCallback(() => {
    const searchURL = new URL(
      `${API_BASE_URL}${apiRoutes.contract}?page[size]=3000`
    );
    setIsContractLoading(true);
    Axios.get(searchURL)
      .then(({ data: apiData }) => {
        const formattedData = formatContractApiData(apiData?.data);
        const newOptions = getContractOptions(
          formattedData,
          excludeSelectOption
        );
        setContracts(newOptions);
      })
      .finally(() => {
        setIsContractLoading(false);
      });
  }, []);

  return {
    contracts,
    handleContractSearch,
    loadNextContractOptionsPage,
    getContractSelectedOption,
    getAllContracts,
    isContractLoading,
  };
};

export default useContractOptions;
